import { render, staticRenderFns } from "./ProductListMicrosite.vue?vue&type=template&id=363249fc&scoped=true&"
import script from "./ProductListMicrosite.vue?vue&type=script&lang=js&"
export * from "./ProductListMicrosite.vue?vue&type=script&lang=js&"
import style0 from "./ProductListMicrosite.vue?vue&type=style&index=0&id=363249fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363249fc",
  null
  
)

export default component.exports